module.exports = __webpack_public_path__ + "img/logo.keele.59fc8079.png";